import React from 'react';
import { marked } from 'marked';
import clsx from 'clsx';
import styles from './Markdown.module.css';

interface Props {
  children: string;
  className?: string;
}

export function Markdown(props: Props): React.ReactElement {
  const { children, className } = props;
  return (
    <div
      className={clsx(styles.markdown, className)}
      dangerouslySetInnerHTML={{ __html: marked.parse(children).toString() }}
    />
  );
}
